/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import SectionContainer from '../../modules/SectionContainer';
import Button from '../../base/Button';
import Typography from '../../base/Typography';
import ChevronLeftIcon from '../../icons/utility/ChevronLeft';

export const SectionStyled = styled(SectionContainer)`
  ${({ theme }) => css`
    && {
      background-color: ${theme.colors.primary.blue};
      width: 100%;
      position: relative;
      padding: 0;
      max-width: unset;
      && {
        > .nmx-container {
          max-width: unset;
          padding: 0;
        }
      }
      @media print {
        display: none !important;
      }
    }
  `}  
`;

// SAVE IF DESIGN CHANGES THEIR MINDS ABOUT HAVING A STATIC HEIGHT FOR ALL MOBILE VIEWS
// returns string name of the active view.
const getCurrentView = (views) => {
  const obj = Object.entries(views);
  for (let i = 0; i < obj.length; i += 1) {
    if (obj[i][1]) {
      return obj[i][0];
    }
  }
  return false;
};

// GOTCHA: The view container height is going to have to be handled manually
// for each view, since this container will not expand with its
// position absolute children.
export const DivViewContainerStyled = styled.div`
${({ theme, views }) => {
    const largeUp = theme.useMediaQuery(theme.breakpoints.up('large'));
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    const largeHeight = rem(295); // consistant large device height throughout the flow.
    const mediumHeight = rem(410); // default height, works for all views except step 2
    let xsmallHeight = rem(700); // default
    let height;

    // SAVE IF DESIGN CHANGES THEIR MINDS ABOUT HAVING A STATIC HEIGHT FOR ALL MOBILE VIEWS
    const activeView = getCurrentView(views);
    // view container height needs to be set manually for each step, since views are position absolute.
    if (activeView === 'isActiveViewStep1') {
      xsmallHeight = rem(380);
    }

    // media queries
    if (largeUp) {
      height = largeHeight;
    } else if (mediumUp) {
      height = mediumHeight;
    } else {
      height = xsmallHeight;
    }

    return css`
      position: relative;
      width: 100%;
      height: ${height};
    }`;
  }
}
`;

// Dynamic, cross-fading views that contain the different steps
export const DivDynamicViewStyled = styled.div`
  ${({
    theme, isActive, isAccessible, centered,
  }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    let visibility = 'hidden';
    let zIndex = -1;
    let opacity = 0;
    let topPadding = rem(48);

    // this state gets a 1.5 s delay before rerendering
    if (isAccessible) {
      visibility = 'visible';
      zIndex = 0;
    }

    // this state rerenders immediately
    if (isActive) {
      opacity = 1;
    }

    if (mediumUp) {
      topPadding = rem(60);
    }

    // isSubmitting, thankYou, and error views are vertically centered.
    return css`
      position: absolute;
      display: ${centered
    ? 'flex'
    : 'block'};
      visibility: ${visibility};
      z-index: ${zIndex};
      width: 100%;
      height: 100%;
      transition: opacity .75s;
      opacity: ${opacity};
      padding-top: ${centered
    ? 0
    : topPadding};
    `;
  }
}
`;

export const DivNextButtonContainerStyled = styled.div`
  ${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    let marginTop = 0;
    let width = '100%';
    if (mediumUp) {
      marginTop = 26;
      width = 'auto';
    }

    return css`
      margin-top: ${rem(marginTop)};
      width: ${width};
    `;
  }
}`;

export const ButtonNextStyled = styled(Button)`
  ${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    let width = '100%';
    if (mediumUp) {
      width = 'auto';
    }
    return css`
      display: block;
      width: ${width};
      ${!mediumUp && 'max-width: unset'};
  `;
  }
}
`;

// Goal dropdown select
// TODO: Noodle on a better way to set input widths.
export const DivInputColStyled = styled.div`
  ${({ theme, inputWidth }) => {
    const largeUp = theme.useMediaQuery(theme.breakpoints.up('large'));
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));

    let width = '100%';
    let paddingRight = rem(10);
    let paddingBottom = 0;

    if (largeUp) {
      paddingRight = rem(12);
      width = rem(inputWidth);
    } else if (mediumUp) {
      paddingRight = rem(15);
      paddingBottom = rem(20);
      width = rem(inputWidth);
    } else {
      paddingRight = 0;
      paddingBottom = rem(20);
    }

    return css`
    position: relative;
    width: ${width};
    padding-right: ${paddingRight};
    padding-bottom: ${paddingBottom}
  `;
  }
}
`;

export const DivProgressBarContainerStyled = styled.div`
  ${({ isActive }) => css`
    opacity: ${isActive
    ? '1'
    : '0'};
  `}
`;

export const ButtonBackStyled = styled(Button)`
  ${({ theme }) => {
    const xlargeUp = theme.useMediaQuery(theme.breakpoints.up('xlarge'));
    const xlargeDown = theme.useMediaQuery(theme.breakpoints.down('xlarge'));
    const largeUp = theme.useMediaQuery(theme.breakpoints.up('large'));
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    const smallUp = theme.useMediaQuery(theme.breakpoints.up('small'));
    let top = -6;
    let left = 5;
    let minWidth = 'unset';

    if (largeUp) {
      minWidth = rem(120);
    } else if (mediumUp) {
      minWidth = rem(80);
    }

    if (mediumUp) {
      top = 12;
    } else if (smallUp) {
      top = -3;
    }

    if (xlargeUp) {
      left = -12;
    } else if (largeUp) {
      left = -17;
    } else if (mediumUp) {
      left = 20;
    }
    return css`
      position: absolute;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      min-width: ${minWidth};
      left: ${rem(left)};
      top: ${rem(top)};
      z-index: 1;
      ${xlargeDown && 'padding-left:0;'}
      :hover {
        .js-in-page-lead-animated-back-button-icon {
          margin-right: ${rem(13)};
        }
      }
  `;
  }
}`;

export const TypographyBackButtonStyled = styled(Typography)`
  padding: 0;
`;

export const IconBackButtonStyled = styled(ChevronLeftIcon)`
  ${({ theme }) => {
    const xlargeUp = theme.useMediaQuery(theme.breakpoints.up('xlarge'));
    let marginTop = -2;

    if (xlargeUp) {
      marginTop = -3;
    }

    return css`
    transition: margin 0.3s;
    padding: 0;
    margin-right: ${rem(7)};
    margin-top: ${rem(marginTop)};
    color: ${theme.colors.neutral.white};
  `;
  }
}
`;
